const data = {
  id: 1,
  title: 'Write a sentence using given words.',
  subTitle: 'Học sinh dựa vào những gợi ý có sẵn để hoàn thành câu.',
  audioUrl: '',
  imageUrl: '',
  question: 'Where/you/from? ___',
  // answers: 'Where are you from',
  answers: [
    { id: 1, answer: 'Where are you from?', isCorrect: true },
    { id: 2, answer: 'Where are you from', isCorrect: true },
  ],
};

export default data;
